import React, {useEffect, useState} from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import GridGallery from '../../components/Gallery/GridGallery';
import NavBar from '../../components/Navbar/NavBar';
import Footer from '../../components/Footer/Footer';
import RatingBox from '../../components/CardsBox/RatingBox';
import './SubscriptionPage.css'
import SliderCardsPrograms from '../../components/Sliders/SliderCardsPrograms';
import SubscriptionBox2 from '../../components/CardsBox/SubscriptionBox2';
import { SubscriptionModal } from '../../components/MujerSoberana/SubscriptionModal';

const SubscriptionPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStripeUrl, setSelectedStripeUrl] = useState('');

  useEffect(() => {
    AOS.init();
  }, [])

  return <>
    <NavBar/>
    <section>
      <h2 className='uppercase text-center text-sb-800 font-[MADE-Bon-Voyage] p-10 text-4xl md:text-6xl'>Membresias</h2>
        <div className="flex flex-wrap justify-center items-start gap-5 md:gap-10">
                <SubscriptionBox2
                  title='Mujer Soberana Mensual'
                  subtitle='Subscripción'
                  price={1111}
                  color='bg-so-600'
                  desc={[
                    "🌿 1 Masterclass con la temática del mes",
                    "🌸 1 Círculo de Palabra (sesión grupal en vivo)",
                    "🔥 1 Sesión especial (meses nones)",
                    "🌕 1 Invitada especial (meses pares)",
                    "🎧 2 Audios activadores (mañana y noche)",
                    "✍️ Journal prompts semanales",
                    "🕯️ Ritual semanal"
                  ]}
                  stripe='https://buy.stripe.com/6oU3cubp8duD5yw0aVffy0X'
                  thumbnail='https://firebasestorage.googleapis.com/v0/b/sara-sasanas-cloud.appspot.com/o/TEST-201%2FMujer_Soberana_thumb_1.webp?alt=media&token=372e194c-95cd-4d41-8064-04190ffb32c6'
                  buttonContent='Unirme ahora'
                  onButtonClick={() => {
                    setSelectedStripeUrl('https://buy.stripe.com/6oU3cubp8duD5yw0aVffy0X');
                    setIsModalOpen(true);
                  }}
                />

                <SubscriptionBox2
                  title='Mujer Soberana Trimestral'
                  subtitle='Subscripción'
                  price={3000}
                  color='bg-sb-600'
                  desc={[
                    '🌸 Acceso completo a la Membresía Mujer Soberana.',
                    '✨ Precio preferencial',
                    '✨ Compromiso con tu proceso',
                    '✨ Acceso gratuito a la plataforma de yoga (más de 150 clases grabadas de distintas duraciones y estilos)'
                  ]}
                  stripe='https://buy.stripe.com/14A3cu64O76f9OMe1Lffy0W'
                  thumbnail='https://firebasestorage.googleapis.com/v0/b/sara-sasanas-cloud.appspot.com/o/TEST-201%2FMujer_Soberana_thumb_2.webp?alt=media&token=71631b24-f8aa-4976-bbd4-210d2f1e4561'
                  buttonContent='Comprometerme 3 meses'
                  onButtonClick={() => {
                    setSelectedStripeUrl('https://buy.stripe.com/14A3cu64O76f9OMe1Lffy0W');
                    setIsModalOpen(true);
                  }}
                />
        </div>
    </section>
    <section>

      <div className="right-content w-full">
        <SliderCardsPrograms/>
      </div>  

    </section>
    
    <section className="rating-section p-20 overflow-hidden relative">
      <div className='mandala-image absolute right-[-250px] opacity-5  mt-32'>
            <img src={require("../../assets/icons/Mandala/mandala-8.png")} alt=""/>
      </div>
      <h2 className='uppercase text-center text-sb-800 font-[MADE-Bon-Voyage] p-10'>Se Parte de la Tribu</h2>
      <div className="rating-boxes box flex flex-wrap justify-center items-center gap-10 z-10">
        <RatingBox name='Marce L' rating={5} description='100% recomiendo tu trabajo y tus ganas!! Eres lo máximo, eres muy coherente en lo que practicas y tu forma de ser ❤️'/>
        <RatingBox name='Andrea R' rating={5} description='Disfrute muchísimo cada práctica, me llenaron de una energía súper bonita y me encanta que no solo es la práctica por cumplir el reto, si no que cada una se intenciona y al final todo se unió 🤍 GRACIAS SARA'/>
        <RatingBox name='Giliano' rating={5} 
        description='Claro que recomiendo este reto. Fue un disfrute practicar cada clase y la intención puesta en cada una de ellas. También me encantó la música, la energía de cada clase. Muchas gracias Saris 💛'/>
        <RatingBox name='Mafer' rating={5} 
        description={`Me llevo la conexión con mi cuerpo, con mi mente y los momentos de quietud que me permiten equilibrar mi día e integrar lo que estoy pasando para sentirlo todo.  Con total certeza recomiendo tus clases, porque más que un reto físico es una transformación en la que al llevar la intención del tapete al exterior la vida se vive más suave.
          En verdad, gracias por tu luz, tu guía, tu contención y tú atención.`}/>
        <RatingBox name='Lupita M' rating={5} description={`Me siento feliz de haber aprendido a darle más consciencia y presencia a mis días con la práctica constante 🙌
          Gracias Sara por poner tu corazón en todo lo que haces y compartirnos prácticas tan maravillosas 🫶 Inspiras 🤍`}/>
      </div>
      <div className='mandala-box absolute left-[-170px] opacity-5  mb-32'>
          <img src={require("../../assets/icons/Mandala/mandala-8.png")} alt=""/>
      </div>
    </section>

    <section className="gallery">
      <GridGallery/>
    </section>
    <Footer/>

    <SubscriptionModal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onSubscribe={(plan) => {
        window.open(selectedStripeUrl, '_blank', 'noopener,noreferrer');
        setIsModalOpen(false);
      }}
    />
  </>
}

export default SubscriptionPage;